var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tag-template',{staticClass:"heading",class:{
		[`heading--${_vm.lineX}`]: true
	},attrs:{"tag":_vm.tag}},[_vm._v("\n\t"+_vm._s(_vm.title)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }